import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const usePaginationStats = (
  tableRef: any,
  totalRecords: any,
  firstRowIndex: number,
  numberOfRowsPerPage: number,
  currentPage: number
) => {
  const { t } = useTranslation(["common"]);
  useEffect(() => {
    if (!tableRef?.current) return;

    const rows = numberOfRowsPerPage;
    const total = totalRecords || 0;

    const calculateFirstAndLast = () => {
      let first = 0;
      let last = total > rows ? rows : total;

      if (currentPage === 0) {
        first = total > 0 ? 1 : 0;
      } else if (currentPage > 0) {
        first = (firstRowIndex ?? 0) + 1;
        last = Math.min(firstRowIndex + rows, total);
      }

      return { first, last };
    };

    const { first, last } = calculateFirstAndLast();

    const updateGridStats = () => {
      const tablePaginator = document.querySelector(".grid-paginator-bottom");
      if (!tablePaginator) return;

      const existingStats = document.querySelector(".grid-stats");
      if (existingStats) {
        existingStats.remove();
      }

      const portalElement = document.createElement("span");
      portalElement.className = "grid-stats";
      portalElement.innerHTML = `${first} ${t("to")} ${last} ${t(
        "of"
      )} ${total}`;
      tablePaginator.prepend(portalElement);
    };

    updateGridStats();
  }, [
    tableRef,
    firstRowIndex,
    totalRecords,
    t,
    numberOfRowsPerPage,
    currentPage,
  ]);
};

export default usePaginationStats;
